import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import moment from 'moment';
import xlsx from 'xlsx';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimesCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';
import { dateFormatter } from '../../../lib/formatter';

const ExcelDownload = ({
  isOpen,
  toggle,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenExcelDownloadFailModal, setIsOpenExcelDownloadFailModal ] = useState(false);
  const [ messageExcelDownloadFail, setMessageExcelDownloadFail ] = useState('');
  const { filterItem } = useSelector(state => state.bookingList);
  const { hotelName } = useSelector(state => state.sidebar);

  const exportDataToExcel = async () => {
    try {
      setIsLoading(true);
      const bookingListApiRes = await api.listBooking({
        ...filterItem,
        startAt: filterItem.startAt || moment().startOf('day').toDate(),
        offset: null,
        limit: null,
      });
      const excelDatas = [];
      bookingListApiRes.data.items.map((booking) => {
        console.log(booking);
        booking.cards.map(card => {
          return excelDatas.push({
            '빌딩': booking.building.name,
            '객실': booking.room.name,
            '투숙객명': card.user_name,
            '전화번호': card.phone_number,
            '입실일자': dateFormatter(card.checkin_at),
            '퇴실일자': dateFormatter(card.checkout_at),
            '생성일자': dateFormatter(card.created_at),
            '키타입': '카드키',
            '카드번호': card.card_no,
          });
        });
        booking.mobilekeys.map(mobilekey => {
          return excelDatas.push({
            '빌딩': booking.building.name,
            '객실': booking.room.name,
            '투숙객명': mobilekey.user_name,
            '전화번호': mobilekey.phone_number,
            '입실일자': dateFormatter(mobilekey.checkin_at),
            '퇴실일자': dateFormatter(mobilekey.checkout_at),
            '생성일자': dateFormatter(mobilekey.created_at),
            '키타입': '모바일키',
            '교환번호': mobilekey.exchangekey,
          });
        });
        booking.pincodes.map(pincode => {
          return excelDatas.push({
            '빌딩': booking.building.name,
            '객실': booking.room.name,
            '투숙객명': pincode.user_name,
            '전화번호': pincode.phone_number,
            '입실일자': dateFormatter(pincode.checkin_at),
            '퇴실일자': dateFormatter(pincode.checkout_at),
            '생성일자': dateFormatter(pincode.created_at),
            '키타입': '출입번호',
            'QR URL': pincode.qr_url,
            '출입번호': pincode.pincode,
          });
        });
        return booking;
      });
      const worksheet = xlsx.utils.json_to_sheet(excelDatas);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, '예약조회');
      xlsx.writeFile(workbook, `${hotelName}_bookings_${moment().format('YYYYMMDDHHmm')}.xlsx`);
      toggle();
    } catch (error) {
      if (!error.response) setMessageExcelDownloadFail(error.message);
      else setMessageExcelDownloadFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenExcelDownloadFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          <FontAwesomeIcon icon={faQuestionCircle} style={{fontSize:'5em', color:'orange'}}/>
          <p className='mb-0 mt-4' style={{fontSize:'16px'}}>
            {t('confirm_message.download_booking')}<br/>
          </p>
          <button className='modal-btn-cancel' onClick={() => toggle()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
          </button>
          <button className='modal-btn-confirm' onClick={() => exportDataToExcel()}>
            <FontAwesomeIcon icon={faSave} style={{paddingRight:'3px'}}/><span>{t('button.ok')}</span>
          </button>
        </ModalBody>
      </Modal>
      <ResponseFailModal
        isOpen={isOpenExcelDownloadFailModal}
        toggle={() => setIsOpenExcelDownloadFailModal(!isOpenExcelDownloadFailModal)}
        message={messageExcelDownloadFail || 'Excel 파일 다운로드에 실패 하였습니다.'}
      />
    </Fragment>
  );
}

export default ExcelDownload;